module.exports = __webpack_public_path__ + "static/6d85fcf6c9a879e0e0e6ea25b1318fc986639fcdf2d7e5f0c87f9b35245d2539-2139b474d558b261c0dfcb9d5e80bbcd.png";